import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gym-testimonial',
  templateUrl: './gym-testimonial.component.html',
  styleUrls: ['./gym-testimonial.component.scss']
})
export class GymTestimonialComponent implements OnInit {
  users = [
    {
      img: 'assets/images/shared/testemonials/avatar1.jpg',
      text: `עם עודד הטבע נפרש כמניפה של תגליות וחידות, אפילו בפשוטים שבמקומות (- הוא עשה את זה עם ברוש שאני מכירה כל החיים ומעולם לא נתתי דעתי על זה שהוא מפותל ולמה) - מתגלים לילדים סודות ורזים, שהם לימדו את חלקם לנו, ההורים, בסיור סיום.
      הערוּת הזאת, הקשב הרב-חושי לטבע, מחלחל גם פנימה, לטבע שבכ"א מהם, ומורה להם את הדרך.
      פשוט קסום.`,
      name: 'יעל זליגמן',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar2.jpg',
      text: 'הייתה סדנא אדירה! לנסות בעצמי להתחקות כמה מאות מטרים אחר עקבות של צבי ושל חזיר בר במטרה להגיע לחיה הייתה חוויה מאתגרת ומרגשת ',
      name: ' רועי רוסטמי',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar3.jpg',
      text: `איש שטח בכל רמ"ח אבריו ומדריך בחסד! מנוסה, בעל ידע עצום, אדיב וסבלן, ועושה את עבודתו מתוך אהבה אמיתית! פשוט תענוג! אשרייך`,
      name: 'איתמר ברקאי',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar4.jpg',
      text: `היינו עם הילדים בסדנת גששות שעודד העביר, הייתה חוויה מאוד מיוחדת והילדים נהנו בטירוף!
      עודד היה מדהים עם הילדים, הם הלכו אחריו מוקסמים. גם אנחנו ההורים מאוד נהנינו מהידע והניסיון.
      מומלץ בחום!`,
      name: 'אילה הולנד',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar1.jpg',
      text: `חוויה ייחודית ומדהימה. עודד יודע לחבר את הגדולים והקטנים אל הטבע, מעורר מחשבה ואת הרצון לחקור ולחפש את בעלי החיים מסביבנו. טיול משפחות באווירה נעימה, מתאים למגוון רחב של גילאים`,
      name: 'סיגל קרופניק',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar2.jpg',
      text: `בעזרת אהבה רבה לטבע, ידע ואווירה כיפית ומשוחררת הסדנא של "גששות-בעקבות הטבע" הייתה דרך נהדרת לברוח מהעיר, להתחבר בחזרה לטבע ולגלות עולם שלם של חיות וחיים
      חוויה אמיתית ...ממליץ בחום
      `,
      name: 'רועי פינקלמן',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar3.jpg',
      text: `עודד חי ונושם טבע. איש שטח אמיתי, תמיד כייף לטייל איתו וללמוד ממנו. ממליץ בחום!!`,
      name: 'עמית גולדברג',
      roll: ''
    },
    {
      img: 'assets/images/shared/testemonials/avatar4.jpg',
      text: `עודד איש שטח בכל רמ"ח אבריו.
      סוחף אחריו את הילדים ואת הוריהם לתוך עולם הגששות.`,
      name: 'יואב וקנין',
      roll: ''
    },
  ];

  testimonialCarouselOptions = {
    items: 1,
    margin: 0,
    dots: true,
    nav: false,
    autoplay: false,
    slideSpeed: 5000,
    paginationSpeed: 1000,
    loop: true
  };

  constructor() { }

  ngOnInit() { }
}
